export default "__VITE_ASSET__ghMTApY5__"